"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'CollectionDetailDialog',
  data: function data() {
    return {
      dialogVisible: false,
      // 静态 mock 数据
      detail: {
        merchantType: '核销商家',
        merchantName: '家家乐',
        periodStart: '2025-05-01 00:00:00',
        periodEnd: '2025-05-31 23:59:59',
        orderAmount: 100,
        orderCount: 10,
        beanDeduction: 70,
        thirdPartyDeduction: 10,
        couponDiscount: 10,
        pointsDeduction: 10,
        lossAmount: 0
      },
      cardDeductionList: [{
        cardName: '金豆',
        actualDeduction: 200
      }, {
        cardName: '普通福豆',
        actualDeduction: 300
      }]
    };
  },
  methods: {
    open: function open(row) {
      if (row) {
        this.detail.merchantName = row.merchantName || this.detail.merchantName;
        this.detail.merchantType = row.merchantType || this.detail.merchantType;
        this.detail.periodStart = row.periodStart || this.detail.periodStart;
        this.detail.periodEnd = row.periodEnd || this.detail.periodEnd;
      }
      this.dialogVisible = true;
    }
  }
};